export type MachineTab = 'overview' | 'telemetry' | 'alarms' | 'tools';

const TABS: readonly { key: MachineTab; label: string }[] = [
  { key: 'overview', label: 'Overview' },
  { key: 'telemetry', label: 'Telemetry' },
  { key: 'alarms', label: 'Alarms' },
  { key: 'tools', label: 'Tools' },
];

export interface TabBarProps {
  readonly active: MachineTab;
  readonly onChange: (tab: MachineTab) => void;
}

export function TabBar({ active, onChange }: TabBarProps): JSX.Element {
  return (
    <div role="tablist" className="flex border-b border-border mb-5">
      {TABS.map((tab) => {
        const selected = tab.key === active;
        return (
          <button
            key={tab.key}
            role="tab"
            aria-selected={selected}
            type="button"
            onClick={() => onChange(tab.key)}
            className={[
              'px-3 py-2 text-sm font-mono transition-colors -mb-px border-b-2',
              selected
                ? 'border-b-accent text-text'
                : 'border-b-transparent text-text-dim hover:text-text',
            ].join(' ')}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
